import { store } from "~/state/store";
import { addMarker, removeMarker, updateMarker, addGeometry, removeGeometry, updateGeometry } from "~/state/map-content/state";
import { TBulkOperations } from "./interfaces";

export function applyStoreItem(operData: TBulkOperations) {
	switch (operData.type) {
		case "add-marker":
			// store
			store.dispatch(addMarker(operData.data));
			break;

		case "update-marker":
			// store
			store.dispatch(updateMarker({
				id: operData.id,
				data: operData.data,
			}));
			break;

		case "remove-marker":
			// store
			store.dispatch(removeMarker(operData.id));
			break;

		case "add-geometry":
			// store
			store.dispatch(addGeometry(operData.data));
			break;

		case "update-geometry":
			// store
			store.dispatch(updateGeometry({
				id: operData.id,
				data: operData.data,
			}));
			break;

		case "remove-geometry":
			// store
			store.dispatch(removeGeometry(operData.id));
			break;

		default:
	}
}
